module.exports = __webpack_public_path__ + "static/media/boy-21.184925d8.svg";